import React from 'react';

import { connect } from 'react-redux';

import { withStyles, MuiThemeProvider, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';

import moment from "moment";

import { AppState, IPageState } from '../../appredux'

import { fontSelect } from '../../fonts';

import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

type InfoProps = {
  page: IPageState,
}

class Info extends React.Component<InfoProps & WithStyles<typeof styles>, any> {
  textTheme = fontSelect(this.props.page.fonts, 12, 2) as React.CSSProperties;

  //PM 2021-03-17
  render() {
    const classes = this.props.classes;
    let date = moment().format("HH:mm")
    return (
      <>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" component="h2" color="primary" style={this.textTheme}>
            <HelpOutlineIcon className={classes.icon}/>
          </Typography>
          <Typography variant="h6" component="h2" color="primary" style={this.textTheme}>
            kwota zamówienia max: <strong>{this.props.page.info.www_sprzedaz_kwota_limit_max + ".00 zł"}</strong>
          </Typography>
          <Typography variant="h6" component="h2" color="primary" style={this.textTheme}>
            kwota zamówienia min: <strong>{this.props.page.info.www_sprzedaz_kwota_limit_min + ".00 zł"}</strong>
          </Typography>
          <Typography variant="h6" component="h2" color="primary" style={this.textTheme}>
            ilość pozycji w koszyku max: <strong>{this.props.page.info.www_sprzedaz_ilosc_limit}</strong>
          </Typography>
          <Typography variant="h6" component="h2" color="primary">
            <p></p>
          </Typography>
          <Typography variant="h6" component="h2" color="primary" style={this.textTheme}>
            twój adres ip: <strong>{this.props.page.info.ip}</strong>
          </Typography>
          <Typography variant="h6" component="h2" color="primary" style={this.textTheme}>
            twój dostawca: <strong>{"---"}</strong>
          </Typography>
          <Typography variant="h6" component="h2" color="primary" style={this.textTheme}>
            twoja sesja: <strong>{date}</strong>
          </Typography>
          <Typography variant="h6" component="h2" color="primary">
            <p></p>
          </Typography>
          <Typography variant="h6" component="h2" color="primary" style={this.textTheme}>
            status info: <strong>{this.props.page.info.www_sprzedaz_error_info}</strong>
          </Typography>
          <Typography variant="h6" component="h2" color="primary" style={this.textTheme}>
            teren dostawy: <strong>{this.props.page.info.www_sprzedaz_dostawa_teren_opis}</strong>
          </Typography>
          <Typography variant="h6" component="h2" color="primary" style={this.textTheme}>
            czas oczekiwania na dostawę: <strong>{this.props.page.info.www_sprzedaz_czas_oczekiwania_info}</strong>
          </Typography>
        </Grid>
        <Grid item xs={12} md={6} >

        </Grid>
      </>
    )
  }
}

const styles = (theme: Theme) => ({
  icon:{
    width: "30px",
    height: "30px",
    paddingBottom: "5px"
  }
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withStyles(styles)(Info));